import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapGetters(['currentTheme', 'display']),
    ...mapState('UI', ['selectedTheme']),

    pButtonColor() {
      return {
        active: `var(--primary_button_color_active)`,
        base: `var(--primary_button_color_base)`,
        hover: `var(--primary_button_color_hover}`,
      };
    },

    sButtonColor() {
      return {
        active: `var(--secondary_button_color_active)`,
        base: `var(--secondary_button_color_base)`,
        hover: `var(--secondary_button_color_hover)`,
      };
    },

    stylesToHead() {
      return `
        .visible-tab:hover, 
        .footer a:hover,
        .show-more:hover, {
          color: var(--hover_text_color);
        } 

        .visible-tab, 
        .payment-header__price__amount, 
        .payment-header__description .payment-header__description__text, 
        .error-page__title, 
        .payment-methods__text, 
        .test-payment__title, 
        .test-payment__description, 
        .footer__custom-select ul, 
        .footer__custom-select__selected,
        .modal-wrap .modal,
        .text-input,
        .payment-status__details__title,
        .payment-status__details__item__description,
        .payment-header__price__edit-amount .input-edit,
        .select-payment__options {
          color: var(--regular_text_color);
        }

        .payment-header__description__wrap .payment-header__description__link,  
        a.flow-redirect-component__cancel {
          color: var(--primary_text_color);
        }

        .footer__custom-select__selected--open span,
        .footer__custom-select__selected:hover,
        #app .payment-methods__select-payment-wrap .select-payment--open,
        #app .payment-methods__select-payment-wrap .select-payment:hover {
          background-color: var(--secondary_button_color_base) !important;
        }

        .visible-tab--active {
          color: var(--active_text_color) !important;
        }

        .tab-underline {
          background-color: var(--active_text_color);
        }

   
        .payment-header__price__edit-amount .input-edit, 
        .payment-header__wrap-logo .payment-header__logo, 
        .mob-search-block .text-input, 
        .payment-methods__select-payment-wrap 
        .select-payment, 
        .mob-globe, 
        .mob-search, 
        .payment-header__price .payment-header__edit-amount,
        .modal-wrap .modal__options li,
        .payment-status__details,
        .footer__custom-select__selected,
        .flow-redirect-component__items li,
        .dpm-fields__field {
          border: solid 1px var(--border_color);
        }

        a.flow-redirect-component__cancel {
          border-top: 1px solid var(--border_color) !important;
        }

        .text-input::placeholder {
          color: var(--placeholder_text_color);
        }

        .footer a, 
        .payment-header__price__edit-amount .currency, 
        .payment-header__description .payment-header__description__time, 
        .payment-header__price,
        .payment-status__details__item__title,
        .payment-header__info__hint__title,
        .powered__text,
        .footer__mob,
        .stub {
          color: var(--secondary_text_color);
        }

       

        .modal-wrap, 
        .redirect-spinner {
          background-color: var(--primary_background_color);
        }

        .modal-wrap .modal,
        li.payment-methods__search-tab .text-input {
          background-color: var(--secondary_background_color);
        }

        ul.modal__options li, 
        .modal-wrap .modal, 
        .payment-header__price__edit-amount .input-edit, 
        .payment-header__price__edit-amount .btn-done, 
        .payment-header__wrap-logo .payment-header__logo, 
        .payment-header__price .payment-header__edit-amount, 
        div.payment-header__logo__description, 
        .mob-search-block .text-input, 
        .payment-methods__select-payment-wrap .select-payment, 
        .select-payment__options, 
        .mob-globe, 
        .mob-search, 
        .payment-methods__item, 
        .payment-methods__icon, 
        .tooltip, 
        .payment-status__details,
        .payment-status__title__logo,
        .footer__custom-select ul,
        .footer__custom-select__selected,
        .btn,
        .text-select,
        .text-select__drop-down,
        .flow-back-invoice__left-side__number-account,
        .flow-back-invoice__right-side,
        .dpm-fields__field {
          border-radius: var(--border_radius);
        }

   
       

      

     
        .btn--transparent {
          border: 1px solid ${this.sButtonColor.base};
          color: ${this.sButtonColor.base};
        }

        .btn--transparent:hover {
          border: 1px solid ${this.sButtonColor.hover};
          color: ${this.sButtonColor.hover};
        }

        .btn--transparent:active {
          border: 1px solid ${this.sButtonColor.active};
          color: ${this.sButtonColor.active};
        }


        .payment-header__edit-amount:hover {
          border: 1px solid ${this.sButtonColor.base};
        }

       

        .payment-header__edit-amount:active {
          border: 1px solid ${this.sButtonColor.active};
        }

        #app .payment-methods__select-payment-wrap .mob-search:hover,
        #app .payment-methods__select-payment-wrap .mob-globe:hover {
          border: 1px solid ${this.sButtonColor.base};
        }

       

        #app .payment-methods__select-payment-wrap .mob-search:active,
        #app .payment-methods__select-payment-wrap .mob-globe:active {
          border: 1px solid ${this.sButtonColor.active};
        }

       

        .tabs-container,
        .payment-methods__search {
          border-bottom: 2px solid var(--base_border_color);
        }
      `;
    },

    mediaStyles() {
      return `
        @media screen and (max-width: 420px) {
          ${this.max420}
        }
        
        @media screen and (min-width: 769px) {
          ${this.min769}
        }

        @media screen and (min-width: 421px) and (max-width: 768px) {
          ${this.min421max768}
        }

        @media screen and (max-width: 768px) {
          ${this.max768}
        }

        @media screen and (min-width: 421px) {
          ${this.min421}
        }

        @media screen and (min-width: 1240px) {
          ${this.min1240}
        }

        @media screen and (min-width: 1050px) {
          ${this.min1050}
        }

        @media screen and (min-width: 851px) and (max-width: 1049px) {
          ${this.min851max1049}
        }
      
        @media screen and (min-width: 734px) and (max-width: 850px) {
          ${this.min734max850}
        }
      
        @media screen and (min-width: 557px) and (max-width: 733px) {
          ${this.min557max733}
        }
      
        @media screen and (max-width: 556px) {
          ${this.max556}
        }

        body {
          position: relative;
        }
      `;
    },

    max556() {
      return `
        // .payment-methods__item:nth-child(2n+1) {
        //   margin-left: 0 !important;
        // }
      `;
    },

    min557max733() {
      return `
        .payment-methods__item:nth-child(3n+1) {
          margin-left: 0 !important;
        }
      `;
    },

    min734max850() {
      return `
        .payment-methods__item:nth-child(4n+1) {
          margin-left: 0 !important;
        }
      `;
    },

    min851max1049() {
      return `
        .payment-methods__item:nth-child(5n+1) {
          margin-left: 0 !important;
        }
      `;
    },

    min1050() {
      return `
        .payment-methods__item:nth-child(6n+1) {
          margin-left: 0 !important;
        }
      `;
    },

    min1240() {
      return `
        .payment-header__flash-message {
          width: 1200px;
        }
      `;
    },

    min421() {
      return `
        .payment-header__flash-message {
          margin-top: 20px;
          width: calc(100% - 40px);
          top: 0;
          font-size: 16px;
          line-height: 1.5;
          border-radius: var(--border_radius);
        }

        .payment-header__flash-message .flash-message__close {
          align-items: baseline;
        }

        .payment-status {
          margin-bottom: 0 !important;
        }

        .payment-status__title {
          margin-bottom: 0 !important;
        }

        .payment-header__flash-message .flash-message__details {
          margin-top: 10px;
        }
      `;
    },

    max420() {
      return `
        .payment-header__flash-message {
          margin-top: 0;
          top: 0;
          left: 0;
          font-size: 12px;
          line-height: 1.33;
          border-radius: 0 0 var(--border_radius) var(--border_radius);
          box-shadow: none !important;
          width: 100%;
        }

        .btn,
        .dpm-fields {
          width: calc(100% - 40px);
          width: 100%;
        }

        .dpm-fields__container {
          width: 100%;
        }

        .payment-header__flash-message .flash-message__close {
          align-items: top;
        }

        .show-more {
          right: 20px;
        }

        #app,
        .dpm-fields__field {
          width: 100%;
        }
      
        .payment-header {
          padding: 20px 0;
          margin: 0 20px;
        }
      
        .payment-methods__tabs-wrapper {
          margin-bottom: 10px;
          padding: 0 20px;
        }
    
        .payment-methods__select-payment-wrap {
          padding: 0;
        }
    
        .payment-methods .payment-tabs__border {
          width: calc(100% - 40px) !important;
          left: 20px;
          right: 0;
        }
        
        .payment-status {
          align-items: flex-start !important;
          width: 100%;
        }
      
        .payment-status__details {
          background-color: transparent !important;
          border: none;
          height: 100%;
          padding: 20px 20px !important;
          width: 100% !important;
          box-shadow: none !important;
        }
      
        .payment-status__details div:not(:last-child) {
          margin-bottom: 10px;
        }
      
        .payment-status__details__title {
          font-size: 24px;
          font-weight: bold;
          line-height: 1.25;
          text-align: left;
        }
          
        .payment-status__wrap {
          width: 100%;
        }
      
        .payment-status__title {
          height: 40px;
          width: 100%;
          flex-direction: row-reverse;
          justify-content: space-between !important;
        }
      
        .payment-status__title__logo {
          margin-right: 20px;
        }
      
        .payment-status__title__text {
          margin-left: 20px !important;
          color: #fff !important;
          line-height: 1.33 !important;
          font-size: 12px !important;
        }
      
        #app .payment-methods__select-payment-wrap .select-payment__options {
          width: calc(100% - 40px);
          left: 20px;
        }

        .payment-wrap__items {
          padding-top: 0 !important;
          margin: 0 20px;
        }

        .payment-methods__item {
          padding: 6px !important;
          box-shadow: 0 1px 1px 0 rgba(215, 216, 219, 0.3);
        }


        .modal-wrap .modal__options li {
          width: 100%;
        }

        .flash-message__details {
          margin-top: 5px;
        }
      `;
    },

    min769() {
      return `
        #app {
          width: 1200px;
          margin: 0 20px;
        }
      
        .payment-header {
          padding: 0px 0 55px 0;
          padding: 40px 0 55px 0;
        }
      `;
    },

    commonModal() {
      return `
        body {
          display: flex;
          justify-content: center;
        }

        .app-wrapper-component {
          margin-top: 150px;
          border-radius: var(--border_radius);
          position: relative;
          margin-top: 150px;
          box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.5);
        }

        .app-wrapper-component .app-wrapper__close {
          position: absolute;
          right: -60px;
          border-radius: var(--border_radius);
          width: 40px;
          height: 40px;
          background-color: #0055cc;
          cursor: pointer;
        }

        .app-wrapper-component .app-wrapper__close:hover {
          background-color: #00a2f3;
        }

        .app-wrapper-component .app-wrapper__close:active {
          background-color: #3d6399;
        }

        .payment_wrap {
          overflow: hidden;
          position: relative;
        }
        .payment-header__flash-message {
          border-radius: var(--border_radius) !important;
        }

        .test-payment {
          margin-top: 30px !important;
        }
      `;
    },

    min421max768() {
      return `
        #app {
          width: 100%;
        }

        .payment-header {
          padding: 20px 0;
          margin: 0 20px;
        }

        .payment-header__edit-amount {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: var(--border_radius);
          cursor: pointer;
          width: 24px;
          height: 24px;
          margin-left: 10px;
        }

        .payment-status__wrap {
          width: 329px;
        }
        
        .payment-status__details {
          width: calc(100% - 20px);
          height: 100%;
          padding 10px 0 !important;
          box-shadow: none;
        }

        .payment-status div:not(:last-child) {
          margin-bottom: 10px;
        }

        .payment-status__title {
          font-size: 24px;
          font-weight: bold;
          line-height: 1.25;
          text-align: center;
        }

        .payment-methods__tabs-wrapper {
          width: calc(100% - 40px);
          margin-left: 20px;
        }

        .payment-wrap__items {
          margin-left: 20px;
        }

        .payment-header__flash-message {
          left: 20px;
        }
      `;
    },

    max768() {
      return `
        #app .customer-contacts { 
          position: unset;
        }

        #app .customer-contacts__info { 
          width: calc(100% - 40px);
        }

        #app .customer-contacts__info__input-info { 
          width: 100%;
        }

        #app .customer-contacts__info__input-info .text-input,
        #app .customer-contacts__info__input-info .text-select { 
          width: 100%;
        }

        #app .customer-contacts__info .btn {
          width: 100%;
        }

        .progress-bar {
          display: none;
        }


        #app .modal-wrap .modal {
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          box-shadow: none;
        }
        
        #app .modal-wrap .modal__options {
          padding-bottom: 30px;
        }

        .payment-header__description {
          display: none !important;
        }

        .payment-header__logo__description {
          padding-left: 0;
          display: flex;
          justify-content: space-between !important;
          z-index: 100;
          right: -20px;
          top: 0;
          height: 180px;
        }

        .payment-header__logo__description .payment-header__description__wrap {
          padding: 20px 15px;
        }

        .payment-header__logo__description .payment-header__description__text {
          max-width: calc(100% - 80px);
        }

        .payment-header__logo__description .mob-close {
          border-top: 1px solid #d7d8db;
          height: 45px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #0055cc;
        }

        .payment-header__info:hover {
          background-color: ${this.sButtonColor.base};
        }

        .payment-header__info--active,
        .payment-header__info:active {
          background-color: ${this.sButtonColor.active};
        }
          
        .payment-header__info {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: var(--border_radius);
          cursor: pointer;
          width: 24px;
          height: 24px;
          margin-left: 10px;
          font-size: 16px;
          font-weight: bold;
        }

        .payment-header__info__hint__title {
          font-size: 12px;
          line-height: 1.33;
        }

        .payment-header__info__hint__description {
          margin-top: 5px;
          font-size: 16px;
          line-height: 1.25;
          word-wrap: break-word;
        }

        .payment-header__info__hint {
          display: block;
          position: absolute;
          border-radius: var(--border_radius);
          width: 100%;
          top: 90px;
          left: 0;
          padding: 10px 0 15px 10px;
          z-index: 1000;
          background-color: #ffffff;
          box-shadow: 0 3px 6px 0 rgba(45, 52, 64, 0.3), 0 0 0 1px rgba(45, 52, 64, 0.1);
          font-weight: normal;
        }

        .payment-methods__select-payment-wrap {
          width: 100%;
        }

        .payment-methods .payment-tabs {
          margin: 0 20px;
          white-space: nowrap;
          overflow: hidden;
        }
        
        #app .payment-methods__search {
          display: none;
        }

        #app .test-payment__title,
        #app .test-payment__description {
            width: calc(100% - 40px);
        }
        

        .flow-redirect-component {
          margin-top: 40px;
        }

        .flow-redirect-component__title,
        .flow-redirect-component__items,
        .dpm-fields {
            width: calc(100% - 40px);
            width: 100%;
        }

        #app .error-page {
          padding: 0 20px;
        }

        #app .flow-back-invoice {
          flex-direction: column;
          align-items: center;
          margin-top: 0;
          height: auto;
        }

        #app .flow-back-invoice__left-side,
        #app .flow-back-invoice__right-side {
          width: 100%;
        }

        #app .flow-back-invoice__right-side {
          margin-top: 20px;
          min-height: 340px;
          width: calc(100% - 40px);
          padding-right: 20px;
        }

        #app .flow-back-invoice__right-side__print {
          position: unset;
          margin-top: 30px;
          margin-bottom: 14px;
        }

        #app .flow-back-invoice__left-side {
          margin-right: unset;
        }

        #app .flow-back-invoice__left-side__number-account__title {
          text-align: center;
        }

        #app .flow-back-invoice__left-side__number-account__number {
          font-weight: bold;
          font-size: 24px;
          text-align: center;
        }

        #app .flow-back-invoice__left-side__description {
          margin-top: 20px;
        }

        #app .flow-back-invoice__left-side__description li {
          font-size: 12px;
        }

        #app .flow-back-invoice .btn {
          justify-content: center;
          margin: 20px auto 0 auto;
          display: flex;
        }

        #app .redirect {
          width: 100%;
          left: 0;
        }

        #app .redirect__description {
          width: calc(100% - 40px);
          margin: 20px auto 0 auto;
        }

        #app .shipping-info {
          width: unset;
          position: unset;
          height: unset;
        }

        #app .shipping-info__info {
          width: calc(100% - 40px);
        }

        #app .shipping-info__info__input-info {
          width: 100%;
        }

        #app .shipping-info__info__input-info .text-input,
        #app .shipping-info__info__input-info .text-select {
          width: 100%;
        }

        #app .shipping-info__info .btn {
          width: 100%;
        }
      `;
    },
  },
};
